var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "btn-group" },
    [
      _c(
        "el-tooltip",
        { attrs: { content: "Terminate", placement: "top", effect: "light" } },
        [
          _vm.canTerminate
            ? _c(
                "button",
                {
                  staticClass: "btn btn-danger btn-sm",
                  on: { click: _vm.confirmTerminating },
                },
                [_c("i", { staticClass: "fas fa-times fa-fw" })]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }